<template>
  <div class="sdg-wrapper-container">
    
    <router-view/>

    <div class="back-button" @click="goBack()">
      <i class="fas fa-chevron-circle-left"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SdgWrapper',
  data() {
    return {
      key: "value"
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.sdg-wrapper-container {
  position: relative;
  min-height: 100vh;
  color: $gText;
}

.back-button {
  position: absolute;
  bottom: 20px;
  right: 20px;
  font-size: 40px;
}
</style>
